import AiProvider from "./AiProvider";
import { lazyAiComponent } from "./lazyAiComponent";

const CallTranscript = lazyAiComponent("CallTranscript");

const AiCallSummary = ({
  callSid,
  isCallRecordingEnabled,
  aiSummaryDisabled = false,
  showCallCoaching = false,
}) => (
  <AiProvider>
    <CallTranscript
      callSID={callSid}
      callRecordingDisabled={!isCallRecordingEnabled}
      aiSummaryDisabled={aiSummaryDisabled}
      showCallCoaching={showCallCoaching}
    />
  </AiProvider>
);

export default AiCallSummary;
